/* Dev Theme Dan – Startseite Handy: lange Texte mit "Mehr lesen" kürzen (Dan, 06.10.) */
(function () {
  if (!window.matchMedia('(max-width: 798px)').matches) return;
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var L = { de: ['Mehr lesen', 'Weniger anzeigen'], fr: ['Lire la suite', 'Afficher moins'], it: ['Leggi di più', 'Mostra meno'] }[lang] || ['Mehr lesen', 'Weniger anzeigen'];
  function run() {
    document.querySelectorAll('.rich-text__text').forEach(function (t) {
      if (t.classList.contains('dmh-clamp') || t.scrollHeight < 520) return;
      t.classList.add('dmh-clamp');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dmh-more';
      b.textContent = L[0];
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = t.classList.toggle('is-open');
        b.textContent = L[open ? 1 : 0];
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      t.parentNode.insertBefore(b, t.nextSibling);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
